<template>
  <div v-if="currentObjectif">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="createModal"
              >
                <i class="fas fa-plus"></i>
                Nouvelle note
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelection"
                v-show="isSelect"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <DataTable
                ref="datatable"
                :currentObjectif="currentObjectif"
                :headers="headers"
                @onSelect="onSelectRows"
                @onRowShow="showModal"
                @onRowEdit="editModal"
                @onRowsDelete="deleteRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNote
      ref="modalNote"
      :currentObjectif="currentObjectif"
      @onRefresh="refresh"
    />
  </div>
</template>

<script>
import URL from '@/http/rh/employe-objectif';
import DataTable from '../components/DataTable.vue';
import ModalNote from '../components/ModalNote.vue';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isSelect: false,
      headers: [
        {
          text: 'Titre',
          align: 'start',
          sortable: true,
          value: 'titre',
        },
        {
          text: 'Auteur',
          align: 'start',
          sortable: true,
          value: 'created_by',
        },
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'date',
        },
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'description',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  components: {
    DataTable,
    ModalNote,
  },
  computed: {
    ...mapGetters('employe', ['currentObjectif']),
  },
  methods: {
    refresh() {
      this.$refs.datatable.loadItems();
      this.isSelect = false;
    },
    createModal() {
      this.$refs.modalNote.create();
    },
    showModal(id) {
      this.$refs.modalNote.show(id);
    },
    editModal(id) {
      this.$refs.modalNote.edit(id);
    },

    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.NOTE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.refresh();
              })
              .catch();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
